module.exports = __webpack_public_path__ + "static/whiteelephantsuitcase-301d1fc87ae015658ac9c9103d221835.jpeg";